import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCertificate,
    faCashRegister,
    faPlus,
} from '@fortawesome/free-solid-svg-icons'

const ItemTenantBackoffice = ({ tenant, history }) => {
    const goAddSucursal = () => {
        history.push('/add-sucursal', {
            tenantId: tenant.id,
            tenantNombre: tenant.nombre,
        })
    }

    const goAddPuntoVenta = () => {
        history.push('/add-punto-venta', {
            tenantId: tenant.id,
            tenantNombre: tenant.nombre,
        })
    }

    const goAddDatoFiscal = () => {
        history.push('/add-dato-fiscal', {
            tenantId: tenant.id,
            tenantNombre: tenant.nombre,
        })
    }

    return (
        <tr>
            <td>{tenant.id}</td>
            <td>{tenant.nombre}</td>
            <td>
                <button
                    type="button"
                    className="btn btn-outline-success btn-sm mr-1"
                    onClick={goAddSucursal}
                    title="Nueva sucursal"
                >
                    <FontAwesomeIcon icon={faPlus} /> Sucursal
                </button>
                <button
                    type="button"
                    className="btn btn-outline-info btn-sm mr-1"
                    onClick={goAddPuntoVenta}
                    title="Nuevo punto de venta"
                >
                    <FontAwesomeIcon icon={faCashRegister} /> PV
                </button>
                <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={goAddDatoFiscal}
                    title="Nuevo dato fiscal"
                >
                    <FontAwesomeIcon icon={faCertificate} /> Fiscal
                </button>
            </td>
        </tr>
    )
}

export default ItemTenantBackoffice
